import './vendor';

import './components/_header';
import './components/_section-instant';
import './components/_section-data';
import './components/_section-winners';
import './components/_dropdown';
import './components/_modal';
import './components/_form';
